import { useState } from "react";
import { iPhone, loginScreenshots } from "utils/assets_exports/images";

const Slider = () => {
    const [showSlide, setShowSlide] = useState<number>(0);

    const changeShowSlide = () => {
        if (showSlide >= loginScreenshots.length - 1) {
            setShowSlide(0);
        } else {
            setShowSlide(() => showSlide + 1);
        }
    };

    setTimeout(changeShowSlide, 3000);

    return (
        <div className="slider">
            {/* <!-- IOS simulator img --> */}
            <img src={iPhone} className="my-slider-container" alt="mobile" />
            {/* <!-- Slideshow container --> */}
            <div className="slideshow-container">
                {/* <!-- 01 --> */}
                {/* <div className="mySlides fade">
                    <img src="{{url('assets/img/screen_shots/01.PNG')}}" />
                </div> */}
                {loginScreenshots.map((screenshot, index) => (
                    <div
                        className={`${showSlide == index ? "d-block" : "d-none"} mySlides fade`}
                    >
                        <img key={screenshot} src={screenshot} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Slider;
